import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 17.73 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M16.46 0H1.27C.57 0 0 .57 0 1.27v3.38c0 .7.57 1.27 1.27 1.27h.16v13.3c0 1.54 1.25 2.79 2.79 2.79h9.29a2.8 2.8 0 0 0 2.8-2.79V5.91h.16c.7 0 1.27-.57 1.27-1.27V1.27c0-.7-.57-1.27-1.27-1.27Zm-.63 1.9v1.85H1.9V1.9zm-2.32 18.31H4.22c-.55 0-1-.45-1-1v-1.16H7.6V7.91H3.22v-2h11.29v13.3c0 .55-.45 1-1 1m-9.92-4.07V9.81H5.7v6.33z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }